import React, { useCallback, useEffect, useState } from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../oms.css";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import Loading from "../../../Assets/Images/OMS_New/unloading.svg";
import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import toast from "react-hot-toast";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function OrderBrokerage({ orderId, omsData, merchantType, getOMSData }) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";
  const [isExpanded, setIsExpanded] = useState(false);

  const [open, setOpen] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [brokers, setBrokers] = useState([]);

  const getBrokers = async () => {
    try {
      const { data } = await axios.get(`/api/oms/broker`);
      if (data?.status) {
        setBrokers(data.broker?.rows || []);
      }
    } catch {}
  };

  useEffect(() => {
    getBrokers();
  }, []);

  useEffect(() => {
    if (omsData?.oms_brokerages?.length) {
      const brokerage = omsData.oms_brokerages.find(
        (b) => b.merchant_type === merchantType
      );
      if (brokerage) {
        formik2.setFieldValue("broker_id", `${brokerage.broker_id}`);
        formik2.setFieldValue("amount", brokerage.amount);
        formik2.setFieldValue("payment_mode", `${brokerage.payment_mode}`);
      }
    }
  }, [omsData]);

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
    setIsAadharVerified(false);
    setIsPanVerified(false);
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      mobile: null,
      pan: "",
      aadhar: null,
    },
    validate: (values) => {
      const errors = {};
      if (!values.name?.trim()) {
        errors.name = "Broker name required";
      }
      if (!values.mobile) {
        errors.mobile = "Mobile number required";
      } else if (!/^[6-9]\d{9}$/.test(values.mobile)) {
        errors.mobile = "Invalid mobile number";
      }
      if (values.aadhar && !/^[0-9]{12}$/.test(values.aadhar)) {
        errors.aadhar = "Invalid Aadhar number";
      }
      if (values.pan && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(values.pan)) {
        errors.pan = "PAN must be in the format ABCDE1234F";
      }
      if (!values.aadhar && !values.pan) {
        errors.aadhar = "Either aadhar or pan required";
        errors.pan = "Either aadhar or pan required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      if (values.pan && !isPanVerified) {
        return toast.error("Entered pan number not valid");
      }
      if (values.aadhar && !isAadharVerified) {
        return toast.error("Entered aadhar number not valid");
      }
      try {
        const { data } = await axios.post("/api/oms/broker", {
          name: values.name,
          mobile: values.mobile || null,
          aadhar: values.aadhar || null,
          pan: values.pan,
        });
        if (data.status) {
          toast.success("New Broker Added SuccessFully");
          handleClose();
          getBrokers();
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error(error);
      }
    },
  });

  const formik2 = useFormik({
    initialValues: {
      broker_id: null,
      amount: null,
      payment_mode: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.broker_id?.trim()) {
        errors.broker_id = "Broker required";
      }
      if (!values.amount) {
        errors.amount = "Broker amount required";
      }
      if (!values.payment_mode?.trim()) {
        errors.payment_mode = "Payment mode required";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        const { data } = await axios.post("/api/oms/brokerage", {
          order_id: orderId,
          merchant_type: merchantType,
          broker_id: values.broker_id,
          amount: values.amount,
          payment_mode: values.payment_mode,
        });
        if (data.status) {
          toast.success("Brokerage added successfully");
          getOMSData();
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error);
      }
    },
  });

  const validateAadhar = async () => {
    if(!formik.values.aadhar) {
        return;
    }
    setIsValidating(true);
    try {
        const resp = await axios({
            url: '/kyc/v1/aadhaar-validation/aadhaar-validation',
            method: 'post',
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_AADHAR_KYC_TOKEN}`
            },
            data: {
                id_number: formik.values.aadhar
            }
        });
        setIsValidating(false);
        if(resp?.data?.success) {
            toast.success('Valid Aadhar number');
            setIsAadharVerified(true);
        } else {
            toast.error('Unable to verify given aadhar number');
        }
    } catch(err) {
        setIsValidating(false);
        toast.error('Unable to verify given aadhar number');
    }
  };

  const validatePan = async () => {
    if(!formik.values.pan) {
        return;
    }
    setIsValidating(true);
    try {
        const resp = await axios({
            url: '/kyc/v1/pan/pan',
            method: 'post',
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_AADHAR_KYC_TOKEN}`
            },
            data: {
                id_number: formik.values.pan
            }
        });
        setIsValidating(false);
        if(resp?.data?.success) {
            toast.success('Valid pan number');
            setIsPanVerified(true);
        } else {
            toast.error('Unable to verify given pan number');
        }
    } catch(err) {
        setIsValidating(false);
        toast.error('Unable to verify given pan number');
    }
  }

  return (
    <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography id="modal-title" variant="h6" component="h2">
              Enter Broker Details
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box noValidate autoComplete="off" sx={{ mt: 2 }}>
            <form onSubmit={formik.handleSubmit}>
              <TextField
                fullWidth
                label="Broker Name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                margin="normal"
              />
              {formik.errors.name && formik.touched.name ? (
                <div className="text-red-600 text-sm flex justify-start ms-1">
                  {formik.errors.name}
                </div>
              ) : null}
              <TextField
                fullWidth
                label="Mobile Number"
                type="number" onWheel={(e) => e.target.blur()}
                name="mobile"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                margin="normal"
              />
              {formik.errors.mobile && formik.touched.mobile ? (
                <div className="text-red-600 text-sm flex justify-start ms-1">
                  {formik.errors.mobile}
                </div>
              ) : null}
              <TextField
                fullWidth
                label="Aadhar Number"
                type="number" onWheel={(e) => e.target.blur()}
                name="aadhar"
                value={formik.values.aadhar}
                onBlur={validateAadhar}
                onChange={(e) => {
                    formik.handleChange(e)
                    setIsAadharVerified(false);
                }}
                margin="normal"
              />
              {formik.errors.aadhar && formik.touched.aadhar ? (
                <div className="text-red-600 text-sm flex justify-start ms-1">
                  {formik.errors.aadhar}
                </div>
              ) : null}
              <span>OR</span>
              <TextField
                fullWidth
                label="PAN Number"
                name="pan"
                value={formik.values.pan}
                onBlur={validatePan}
                onChange={(e) => {
                    formik.handleChange(e)
                    setIsPanVerified(false);
                }}
                margin="normal"
              />
              {formik.errors.pan && formik.touched.pan ? (
                <div className="text-red-600 text-sm flex justify-start ms-1">
                  {formik.errors.pan}
                </div>
              ) : null}
              <Box display="flex" justifyContent="flex-end" mt={3}>
                <Button disabled={isValidating} type="submit" variant="contained" color="primary">
                  Create Broker
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  sx={{ ml: 2 }}
                >
                  Cancel
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
      <div className="flex flex-col sm:flex-row justify-between">
        <div className="font-medium text-cyan-950 text-md flex gap-2">
          <img src={Loading} alt="" />
          <div style={{ textTransform: "capitalize" }}>
            {merchantType} Brokerage
          </div>
        </div>
        <div>
          {isExpanded ? (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Up}
                alt=""
                role="button"
                onClick={() => setIsExpanded(!isExpanded)}
              />
            </div>
          ) : (
            <div className="font-medium text-cyan-950 text-lg mt-2">
              <img
                src={Down}
                alt=""
                role="button"
                onClick={() => setIsExpanded(!isExpanded)}
              />
            </div>
          )}
        </div>
      </div>
      <div>
        <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
      </div>
      <div>
        {isExpanded ? (
          <></>
        ) : (
          <div>
            <form onSubmit={formik2.handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                <div className="mb-3">
                  <label htmlFor="broker_id" className="form-label">
                    Select Broker
                  </label>
                  <select
                    id="broker_id"
                    className="form-select"
                    aria-label="Default select example"
                    name="broker_id"
                    value={formik2.values.broker_id}
                    onChange={formik2.handleChange}
                    disabled={isPending}
                  >
                    <option value="">--Select Broker--</option>
                    {brokers?.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  {formik2.errors.broker_id && formik2.touched.broker_id ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik2.errors.broker_id}
                    </div>
                  ) : null}
                  OR{" "}
                  <Button
                    disabled={isPending}
                    type="button"
                    onClick={() => setOpen(true)}
                  >
                    Add New
                  </Button>
                </div>

                <div className="mb-3">
                  <div>
                    <label htmlFor="amount" className="form-label">
                      Amount
                    </label>
                  </div>
                  <div className="d-flex align-items-center">
                    <input
                      id="amount"
                      type="number" onWheel={(e) => e.target.blur()}
                      className="form-control"
                      onChange={formik2.handleChange}
                      name="amount"
                      placeholder="Enter brokerage amount"
                      value={formik2.values.amount}
                      disabled={isPending}
                    />
                  </div>
                  {formik2.errors.amount && formik2.touched.amount ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik2.errors.amount}
                    </div>
                  ) : null}
                </div>

                <div className="mb-3">
                  <div>
                    <label htmlFor="payment_mode" className="form-label">
                      Payment Mode
                    </label>
                  </div>
                  <div className="d-flex align-items-center">
                    <input
                      id="payment_mode"
                      type="text"
                      className="form-control"
                      onChange={formik2.handleChange}
                      name="payment_mode"
                      placeholder="Enter brokerage payment mode"
                      value={formik2.values.payment_mode}
                      disabled={isPending}
                    />
                  </div>
                  {formik2.errors.payment_mode &&
                  formik2.touched.payment_mode ? (
                    <div className="text-red-600 text-sm flex justify-start ms-1">
                      {formik2.errors.payment_mode}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-end mt-2">
                <Button
                  type="submit"
                  variant="contained"
                  size="small"
                  sx={{ backgroundColor: "#0D9223" }}
                  disabled={isPending}
                >
                  SAVE
                </Button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderBrokerage;
